import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../Pages/Dashboard";

// Calender
import Calender from "../Pages/Calender";

// E-mail
import Inbox from "../Pages/E-mail/Inbox";
import ReadEmail from "../Pages/E-mail/ReadEmail";
import EmailCompose from "../Pages/E-mail/EmailCompose";

// Authentication Pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import UserProfile from "../Pages/Settings/UserProfile";

// Utility Pages
import StarterPage from "../Pages/Utility/Starter-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import TimeLine from "../Pages/Utility/TimeLine-Page";
import FAQs from "../Pages/Utility/FAQs-Page";
import Pricing from "../Pages/Utility/Pricing-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// UI Elements
import UiAlerts from "../Pages/UiElements/UiAlerts";
import UiBadge from "../Pages/UiElements/UiBadge";
import UiBreadcrumb from "../Pages/UiElements/UiBreadcrumb";
import UiButtons from "../Pages/UiElements/UiButtons";
import UiCards from "../Pages/UiElements/UiCards";
import UiCarousel from "../Pages/UiElements/UiCarousel";
import UiDropdown from "../Pages/UiElements/UiDropdowns";
import UiGrid from "../Pages/UiElements/UiGrid";
import UiImages from "../Pages/UiElements/UiImages";
import UiLightbox from "../Pages/UiElements/UiLightbox";
import UiModals from "../Pages/UiElements/UiModals";
import UiOffcanvas from "../Pages/UiElements/UiOffcanvas";
import UiRangeSlider from "../Pages/UiElements/UiRangeSlider";
import UiSessionTimeout from "../Pages/UiElements/UiSessionTimeout";
import UiPagination from "../Pages/UiElements/UiPagination";
import UiProgressBars from "../Pages/UiElements/UiProgressBars";
import UiPlaceholders from "../Pages/UiElements/UiPlaceholders";
import UiTabs from "../Pages/UiElements/UiTabs&Accordions";
import UiTypography from "../Pages/UiElements/UiTypography";
import UiToasts from "../Pages/UiElements/UiToasts";
import UiVideo from "../Pages/UiElements/UiVideo";
import UiPopovers from "../Pages/UiElements/UiPopovers&Tooltips";


// Charts
import ApexCharts from "../Pages/Charts/ApexCharts";
import ChartJs from "../Pages/Charts/ChartjsCharts";
import Sparklinechart from "../Pages/Charts/SparklineCharts";
import FloatChart from "../Pages/Charts/FloatCharts";
import JknobCharts from "../Pages/Charts/JqueryKnobCharts";

// Icons
import IconMaterialdesign from "../Pages/Icons/IconMaterialdesign";
import IconFontawesome from "../Pages/Icons/IconFontAwesome";
import IconDripicons from "../Pages/Icons/IconDrip";
import IconBoxicons from "../Pages/Icons/IconBoxicons";


// Custom Pages
import Users from "../Pages/Users/Users";
import AddUser from "../Pages/Users/AddUser";
import UserDetails from "../Pages/Users/UserDetails";
import Clients from "../Pages/Clients/Clients";
import Companies from "../Pages/Companies/Companies";
import CompensationValuation from "../Pages/Valuations/CompensationValuation";
import ProjectCategories from "../Pages/Projects/ProjectCategories";
import Projects from "../Pages/Projects/Projects";
import MappedUsersListTables from "../Pages/Projects/MappedUsers";
import Regions from "../Pages/Regions/Regions";
import Crops from "../Pages/Crops/Crops";
import Districts from "../Pages/Districts/Districts";
import Councils from "../Pages/Councils/Councils";
import Wards from "../Pages/Wards/Wards";
import ChangePassword from "../Pages/Settings/ChangePassword";
import Roles from "../Pages/Security/Roles/Roles";
import PermissionListTables from '../Pages/Users/Permissions/Permissions';
import MortgageValuationListTables from "../Pages/Valuations/Mortgages/MortgageValuation";
import AssignPermissionsPage from "../Pages/Users/Permissions/AssignPermissionsPage";
import CropCategories from "../Pages/Settings/CropCategories";
import AssetValuationListTables from "../Pages/Valuations/Assets/AssetValuation";
import AssetsByCategory from "../Pages/Valuations/Assets/AssetsByCategory";


const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/calendar", component: Calender },

  // Security
  // Security
{ path: "/roles", component: Roles },
{ path: "/roles/:roleId/permissions", component: AssignPermissionsPage },


  // Email
  { path: "/inbox", component: Inbox },
  { path: "/read-email", component: ReadEmail },
  { path: "/compose-email", component: EmailCompose },

  // Utility
  { path: "/pages-starter", component: StarterPage },
  { path: "/pages-timeline", component: TimeLine },
  { path: "/pages-faqs", component: FAQs },
  { path: "/pages-pricing", component: Pricing },

  // UI Elements
  { path: "/ui-alerts", component: UiAlerts },
  { path: "/ui-badge", component: UiBadge },
  { path: "/ui-breadcrumb", component: UiBreadcrumb },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-carousel", component: UiCarousel },
  { path: "/ui-dropdowns", component: UiDropdown },
  { path: "/ui-grid", component: UiGrid },
  { path: "/ui-images", component: UiImages },
  { path: "/ui-lightbox", component: UiLightbox },
  { path: "/ui-modals", component: UiModals },
  { path: "/ui-offcanvas", component: UiOffcanvas },
  { path: "/ui-rangeslider", component: UiRangeSlider },
  { path: "/ui-sessiontimeout", component: UiSessionTimeout },
  { path: "/ui-pagination", component: UiPagination },
  { path: "/ui-progressbars", component: UiProgressBars },
  { path: "/ui-placeholders", component: UiPlaceholders },
  { path: "/ui-tabs-accordions", component: UiTabs },
  { path: "/ui-typography", component: UiTypography },
  { path: "/ui-toasts", component: UiToasts },
  { path: "/ui-video", component: UiVideo },
  { path: "/ui-popovers", component: UiPopovers },

  // Users
  { path: "/users", component: Users },
  { path: "/add-user", component: AddUser },
  { path: "/update-user/:userId", component: AddUser },
  { path: "/userprofile", component: UserProfile },
  { path: "/user-info/:userId", component: UserDetails },

    // Crops
    { path: "/crop-categories", component: CropCategories },

  // Companies & Clients
  { path: "/companies", component: Companies },
  { path: "/clients", component: Clients },

  // Valuation
  { path: "/assets-valuation", component: AssetValuationListTables },
  { path: "/assets-by-category", component: AssetsByCategory },
  { path: "/pahs", component: CompensationValuation },
  { path: "/mortgages-valuation", component: MortgageValuationListTables },

  // Projects
  { path: "/projects", component: Projects },
  { path: "/project-categories", component: ProjectCategories },
  { path: "/mapped-users", component: MappedUsersListTables },

  // Permissions
  { path: "/permissions", component: PermissionListTables },


  // Password
  { path: "/change-password", component: ChangePassword },

  // Setup
  { path: "/crops-setup", component: Crops },
  { path: "/regions-setup", component: Regions },
  { path: "/districts-setup", component: Districts },
  { path: "/councils-setup", component: Councils },
  { path: "/wards-setup", component: Wards },

  // Charts
  { path: "/chart-apexcharts", component: ApexCharts },
  { path: "/chart-chartjscharts", component: ChartJs },
  { path: "/chart-floatcharts", component: FloatChart },
  { path: "/chart-jknobcharts", component: JknobCharts },
  { path: "/chart-sparklinecharts", component: Sparklinechart },

  // Icons
  { path: "/icon-boxicon", component: IconBoxicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },
  { path: "/icon-dripicons", component: IconDripicons },

  // Redirect root
  { path: "/", exact: true, component: () => <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPasswordPage },


  // Errors
  { path: "/pages-404", component: Error404 },
  { path: "/pages-500", component: Error500 },
  { path: "/pages-maintenance", component: Maintenance },
  { path: "/pages-comingsoon", component: ComingSoon },
];

export { authProtectedRoutes, publicRoutes };
